/* istanbul ignore file */

import React from 'react';
import { COOKIE_MODAL_SCRIPT_PRELOAD_URL, DATA_DOMAIN_SCRIPT, DATA_DOMAIN_SCRIPT_TESTING } from '../../constants';
export var CookieModal = function CookieModal(_ref) {
  var _ref$useTestScript = _ref.useTestScript,
    useTestScript = _ref$useTestScript === void 0 ? false : _ref$useTestScript;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("script", {
    "data-domain-script": useTestScript ? DATA_DOMAIN_SCRIPT_TESTING : DATA_DOMAIN_SCRIPT,
    src: COOKIE_MODAL_SCRIPT_PRELOAD_URL
  }), /*#__PURE__*/React.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "function OptanonWrapper() {}"
    },
    type: "text/javascript"
  }));
};